import type { RequestResponse } from '@/types/publicType'
import type {
  continentCountryInterface,
  popularInterface,
  liveInterface
} from '@/types/apiType/homeType'

/**
 * 获取国家列表
 */
export function apiGetCountryList(): Promise<
  RequestResponse<continentCountryInterface[]>
> {
  return getFetchData({
    url: '/h5/h/country',
    method: 'GET',
    loading: true
  })
}

/**
 * 首页1v1列表
 * @param {number} pageNum
 * @param {number} pageSize
 * @param {string} country
 * @param {string} uid
 * @param {0|3|4} tagNum // 类型 0hot / 3young / 4new
 */
export function apiGetPopularList(params: {
  pageNum: number
  pageSize: number
  country: string
  uid: string
  tagNum: 0 | 3 | 4
}): Promise<RequestResponse<popularInterface>> {
  return getFetchData({
    url: '/h5/h/popularPage',
    method: 'GET',
    params
  })
}

/**
 * 获取直播列表
 */
export function apiGetLiveList(params: {
  pageNum: number
  pageSize: number
  country: string
  type: number
}): Promise<RequestResponse<liveInterface>> {
  return getFetchData({
    url: '/h5/h/livePage',
    method: 'GET',
    params
  })
}
